import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import moment from 'moment'
import DatePicker from 'vue2-datepicker'
import Loader from './../../shared/loader'
import CryptoJS from 'crypto-js'
import download from 'downloadjs'
import Pagination from './../../shared/pagination'
import csvHelper from '../importjsontocsv';
import Vue from "vue";
import JsonExcel from "vue-json-excel";
import { BasicSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'
Vue.component("downloadExcel", JsonExcel);
export default {
	name: 'detailedrackauditreport',
	components: {
		Paginate,
		Pagination,
		DatePicker,
		JsonExcel,
		Loader,
		BasicSelect
	},
	data() {
		return {
			reportname: '',
			csvFieldsForXls: {},
			listStockReportDataforxls: [],
			totalPage: 0,
			totalRows: 0,
			currentPage: 1,
			pageLimit: 10,
			// currentPage: 0,
			listAuditData: [],
			listAuditDatacsv: [],
			displayMsg: false,
			successErrorMsg: "",
			fromDateFlt: "",
			toDateFlt: "",
			// totalPage: 0,
			// pageNo: 0,
			listClientData: [],
			listWarehouseData: [],
			clientid: '',
			client: '',
			warehouseid: '',
			warehouse: '',
			ClientErr: '',
			WarehouseErr: '',
			searchFlag: false,
			showSelectWarehouse: false,
			showSelectClient: false,
			loginuserid: '',
			isLoading: false,
			// perPage: 10,
			formattedDate: '',
			user_type: '',
			productid: '',
			rackid: '',
			resultCount: 0,
			userid: '',
			show: false,
			download: true,
			dataFilter2: '',
			isLoadingforxls: false,
			limitExeed: false,
			recordLimit: 0,
			listMerchantIdData: [],
			merchantnameFlt: '',
			merchant: '',
			item: {},
			listMerchantData1: [],
			merchantList: []
		}
	},
	filters: {
		moment: function (dates) {
			return moment(dates).format('DD-MM-YYYY HH:mm:ss');
		}
	},
	mounted() {
		this.calldateFunction()
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.userid = userdetail.userid;
		this.loginuserid = userdetail.userid;
		this.user_type = userdetail.utype;
		this.pageNo = 0;
		this.reportname = this.$t('editedjson.rackAuditReportDetailed');
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		if (localStorage.getItem("selectedClient")!=='undefined')
		{
		this.getMerchantData();
		}
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				// this.getWarehouseList();
				this.getMerchantData();
				this.showSelectWarehouse = true;
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				// this.getClientList();

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;
			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}
		this.getRecordLimit()

	}, // End computed
	methods: {
		calldateFunction: function () {
			this.currentDate = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
			this.toDateFlt = this.currentDate;
			var dt = new Date(this.currentDate);
			dt.setDate(dt.getDate() - 6);
			this.fromDateFlt = dt;
		},
		getMerchantData() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: localStorage.getItem("selectedClient"),
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'merchantList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data && result.data.length > 0) {
						this.listMerchantData = result.data;
						this.item = {
							value: '',
							text: ''
						};
						this.listMerchantData1 = [{ value: '', text: this.$t('common.selectMerchantPlaceHolder') }];
						this.listMerchantData.forEach(ele => {
							this.listMerchantData1.push({
								"value": ele.merchantid,
								"text": ele.merchantname
							})
						})
					}
				}, error => {
					console.error(error)
				})
		},
		reset() {
			this.item = {}
		},
		onSelect(item) {
			this.item = item
			this.merchantnameFlt = item.value
		},
		getRecordLimit() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({

			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getRecordLimit',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data) {
						this.recordLimit = result.data.data;


					}
				}, error => {
					console.error(error)
				})
		},
		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},
		Choosetype() {
			this.show = true;
			this.download = false;
			if (!this.limitExeed) {
				this.getAuditListForXLS(3)


			}
		},
		export(data, filename, mime) {
			let blob = this.base64ToBlob(data, mime)
			download(blob, filename, mime)
		},
		base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
			let bstr = atob(base64)
			let n = bstr.length
			let u8arr = new Uint8ClampedArray(n)
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n)
			}
			return new Blob([u8arr], {
				type: mime
			})
		},
		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},
		dateFormat1(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 00:00:00";
		},
		dateFormat2(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 23:59:59";
		},
		// getClientList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');
		// 		if (this.warehouseid)
		// 			this.input = ({
		// 				warehouseid: this.warehouseid,
		// 			});
		// 		else {
		// 			this.input = {};
		// 		}

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr,
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },

		// getWarehouseList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 			.then(result => {
		// 				// console.log(result.data.data);
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },
		// clientSelected() {
		// 	if (this.clientid != this.client) {
		// 		this.clientid = this.client;
		// 		this.merchantnameFlt = '';
		// 		if (this.user_type != 'warehouse_user') {
		// 			this.listWarehouseData = []
		// 			this.getWarehouseList();
		// 			this.getMerchantData();
		// 			if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 				this.warehouse = this.warehouseid = '';
		// 			} else {
		// 				this.warehouse = ''
		// 			}
		// 		} else {
		// 			if (this.warehouseid && this.clientid) {
		// 				this.getMerchantData();

		// 				//this.getAuditList();
		// 			}
		// 		}
		// 	}
		// 	this.listAuditData = [];
		// 	this.pageno = this.totalPage = 0;
		// },

		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	this.pageno = this.totalPage = 0;
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {

		// 		} else {
		// 			this.getClientList();
		// 		}
		// 	}
		// },

		getAuditList(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			// this.ClientErr = '';
			var dataFilter = {};
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
				this.limitExeed = false;
			}
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				this.ClientErr = this.$t('common.clientError');
				this.pageNo = this.totalPage = 0;
				this.listRackinData = [];
				return false;
			}
			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.pageNo = this.totalPage = 0;
				this.listRackinData = [];
				return false;
			}
			this.isLoading = true;
			this.input = ({
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				warehouseid: localStorage.getItem("selectedWarehouse"),
				clientid: localStorage.getItem("selectedClient"),
				fromdate: this.dateFormat1(this.fromDateFlt),
				todate: this.dateFormat2(this.toDateFlt),
				productid: this.productid,
				rackid: this.rackid,
				csvData: csvCheck,
				userid: this.userid,
				merchantid: this.merchantnameFlt,

			});
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getRackAuditDetailsall',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (csvCheck == 1) {
						if (result.data.data.length > 0) {
							this.listAuditDatacsv = [];
							this.show = true;
							this.download = false;
							this.csvFields = {
								'rackid':  this.$t('common.rackID'),
								'productid': this.$t('common.productId'),
								'eancode': this.$t('inwardList.printData.productDetails.eanCode'),
								'systemqty': this.$t('common.rackID'),
								'scannedqty': this.$t('auditReport.scannedQty'),
								'matchedqty': this.$t('auditReport.matchQty'),
								'excessqty': this.$t('common.excessQty'),
								'excessproduct': this.$t('auditReport.excessProductQty'),
								'shortqty': this.$t('common.shortQty'),
								'createddate': this.$t('auditReport.auditStartDate'),
								'updateddate': this.$t('auditReport.auditCompletedDate'),
								'userid': this.$t('auditReport.auditBy'),
								'merchantname': this.$t('common.merchant'),
								'isapproved': this.$t('auditDiscrepancyLogReport.table.isApproved')

							};
							var dateFilter = [];
							var skipFilter = ['merchantid', 'isapproved'];
							this.listAuditDatacsv = [];
							this.listAuditDatacsv = result.data.data;

							csvHelper.data.jsonToCSV(this.$t('editedjson.rackAuditReportDetailed'), this.listAuditDatacsv, this.csvFields, dateFilter, skipFilter, dataFilter);

							// this.jsonToCSV('RackAuditReportDetailed', this.listAuditDatacsv, this.csvFields, dateFilder, skipFilter);
						} else {
							if (result.data.status == true) {
								this.$alertify.success(this.$t('common.reportSizeError'));
							} else {
								this.$alertify.error(result.data.msg.message);
							}
						}
					} else {
						this.listAuditData = result.data.data;

						if (result.data.errorCode == -1) {
							this.resultCount = 0;
							this.totalRows = 0;
							this.$alertify.error(result.data.msg);
						} else {
							this.totalRows = result.data.count
							if (Number(this.totalRows) > Number(this.recordLimit)) {
								this.limitExeed = true
							}
							this.resultCount = result.data.count
							if (this.totalRows == 0) {
								this.totalPage = 0
							} else if (this.totalRows < 10) {
								this.totalPage = 1
							} else {
								this.totalPage = Math.ceil(this.totalRows / 10)
							}
						}
					}
					this.isLoading = false;
				}, error => {
					console.error(error);
				})
		},
		getAuditListForXLS(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			// this.ClientErr = '';

			this.show = true;
			this.download = false;
			this.dataFilter2 = [];
			var value = '';
			var str = '';

			this.input = ({
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				warehouseid: localStorage.getItem("selectedWarehouse"),
				clientid: localStorage.getItem("selectedClient"),
				fromdate: this.dateFormat1(this.fromDateFlt),
				todate: this.dateFormat2(this.toDateFlt),
				productid: this.productid,
				rackid: this.rackid,
				csvData: csvCheck,
				userid: this.userid,
				merchantid: this.merchantnameFlt,

			});
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);

				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getRackAuditDetailsall',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (csvCheck == 3) {
						if (result.data.data.length > 0) {
							this.listStockReportDataforxls = [];
							this.csvFieldsForXls =[];
							this.csvFieldsForXls[this.$t('common.rackID')] =  'rackid',
							this.csvFieldsForXls[this.$t('product.productId')] ='productid',
							this.csvFieldsForXls[this.$t('inwardList.printData.productDetails.eanCode')] =  'eancode',
							this.csvFieldsForXls[this.$t('common.rackID')] = 'systemqty',
							this.csvFieldsForXls[this.$t('auditReport.scannedQty')] ='scannedqty',
							this.csvFieldsForXls[this.$t('auditReport.matchQty')] = 'matchedqty',
							this.csvFieldsForXls[this.$t('common.excessQty')] = 'excessqty',
							this.csvFieldsForXls[this.$t('auditReport.excessProductQty')] ='excessproduct',
							this.csvFieldsForXls[this.$t('common.shortQty')] =  'shortqty',
							this.csvFieldsForXls[this.$t('common.createdDate')] =  'createddate',
							this.csvFieldsForXls[this.$t('reports.updatedDate')] = 'updateddate',
							this.csvFieldsForXls[this.$t('loginUsers.UserId')] = 'userid',
							this.csvFieldsForXls[this.$t('warehouseRacks.merchant')] = 'merchantname'

							this.listStockReportDataforxls = result.data.data;

						} else {
							if (result.data.status == true) {
								this.$alertify.success(this.$t('common.reportSizeError'));
							} else {
								this.$alertify.error(result.data.msg.message);
							}
						}


					}



				}, error => {
					console.error(error);
				})
		},
		// getPaginationData(currentPage) {
		// 	this.pageNo = (currentPage - 1) * this.perPage;
		// 	this.getAuditList()
		// },
		onPageChange(page) {
			this.currentPage = page;
			this.getAuditList(2)
		},
		AuditListing() {
			this.currentPage = 1;
			this.totalPage = 0;
			this.resultCount = 0;
			this.searchFlag = true;
			this.getAuditList(2);
		},
		resetAuditSerach() {
			this.show = false;
			this.download = true;
			this.fromDateFlt = "";
			this.toDateFlt = "";
			this.listAuditData = [];
			this.pageNo = 0;
			this.clientid = '';
			this.totalPage = 0;
			this.resultCount = 0;
			this.totalRows = 0;
			this.searchFlag = false;
			this.rackid = '';
			this.productid = '';
			this.merchantnameFlt = '';
			if (this.user_type == 'warehouse_user')
				this.client = '';
			else if (this.user_type == 'client_user')
				this.warehouse = '';
			else {
				this.client = '';
				this.warehouse = '';
			}
			this.item = {
				value: '',
				text: ''
			};
			// this.listMerchantData1 = [{ value: '', text: this.$t('common.merchantPlaceholder') }];
			// this.getAuditList();
		},
		onSubmit: function () {
			this.$validator.validateAll().then(() => {
				console.log('form is valid', this.model)
			}).catch(() => {
				console.log('errors exist', this.errors)
			});
		},
	} // end methods

}


// WEBPACK FOOTER //
// ./src/views/components/reports/detailedrackauditreport/detailedrackauditreport.component.js